module.exports = __webpack_public_path__ + "img/index3.33221744.webp";